import { create } from "zustand";
import type { Session, User } from "@supabase/supabase-js";
import { supabase, type Role, roleFromSession } from "@/lib/supabase";

interface AuthState {
  session: Session | null;
  user: User | null;
  role: Role;
  loading: boolean;
  init: () => Promise<void>;
  signIn: (email: string, password: string) => Promise<{ error?: string }>;
  signOut: () => Promise<void>;
}

export const useAuth = create<AuthState>((set) => ({
  session: null,
  user: null,
  role: "kunde_privat",
  loading: true,

  init: async () => {
    const { data } = await supabase.auth.getSession();
    set({
      session: data.session,
      user: data.session?.user ?? null,
      role: roleFromSession(data.session),
      loading: false,
    });
    supabase.auth.onAuthStateChange((_event, session) => {
      set({
        session,
        user: session?.user ?? null,
        role: roleFromSession(session),
      });
    });
  },

  signIn: async (email, password) => {
    const { data, error } = await supabase.auth.signInWithPassword({ email, password });
    if (error) return { error: error.message };
    // Auth-State sofort spiegeln, damit der Caller nicht auf den onAuthStateChange-Listener warten muss.
    set({
      session: data.session,
      user: data.user,
      role: roleFromSession(data.session),
    });
    return {};
  },

  signOut: async () => {
    await supabase.auth.signOut();
    set({ session: null, user: null, role: "kunde_privat" });
  },
}));
